var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClutch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 92,
    viewBox: "0 0 80 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.4558 64.8601C57.8902 68.9644 51.8622 71.2393 45.247 71.2393C30.6644 71.2393 19.9554 60.5304 19.9554 45.8272C19.9554 31.124 30.3237 20.8658 45.247 20.8658C51.7468 20.8658 57.8902 23.0307 62.5711 27.135L65.7528 29.8712L79.8899 15.7394L76.3517 12.5471C68.033 5.03568 56.9886 0.821289 45.2418 0.821289C19.0329 0.821289 0 19.7336 0 45.7171C0 71.5905 19.4889 91.179 45.2418 91.179C57.2088 91.179 68.3685 86.9647 76.5824 79.3326L80 76.1404L65.6428 62.019L62.4558 64.8601Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5537 30.8994C48.5742 30.8994 52.43 32.4965 55.2729 35.3395C58.1158 38.1824 59.7129 42.0382 59.7129 46.0586C59.7129 50.0791 58.1158 53.9349 55.2729 56.7778C52.43 59.6207 48.5742 61.2179 44.5537 61.2179C40.5333 61.2179 36.6775 59.6207 33.8346 56.7778C30.9917 53.9349 29.3945 50.0791 29.3945 46.0586C29.3945 42.0382 30.9917 38.1824 33.8346 35.3395C36.6775 32.4965 40.5333 30.8994 44.5537 30.8994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClutch);
export default __webpack_public_path__ + "static/media/Clutch.9989f6e293b3919b8df91e7006128cf2.svg";
export { ForwardRef as ReactComponent };